import React, { useEffect, useState } from "react";
import { MenuItem, IconButton, Box, TextField, Menu } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function SelectGradeLevel({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  error,
  disabled,
  availableGradeLevels,
  sx,
}) {
  const gradeLevels = Array.isArray(availableGradeLevels)
    ? availableGradeLevels
    : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  // console.log({ gradeLevels });

  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedGradeLevel, setSelectedGradeLevel] = useState(
    Array.isArray(gradeLevels)
      ? gradeLevels?.find((grade) => grade === value)
      : null
  );

  useEffect(() => {
    setSelectedGradeLevel(
      Array.isArray(gradeLevels)
        ? gradeLevels?.find((grade) => grade === value)
        : null
    );
  }, [value]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);
    if (newValue) {
      onChange?.(name, newValue || "");
      setSelectedGradeLevel(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, ""); // Clear the value
    setSelectedGradeLevel(null);
  };

  return (
    <Box>
      <TextField
        label={label}
        placeholder={placeholder}
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disabled}
        value={selectedGradeLevel && value ? selectedGradeLevel : ""}
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            <>
              {selectedGradeLevel && (
                <IconButton edge="end" onClick={handleClear}>
                  <CloseIcon />
                </IconButton>
              )}
              {!disabled && !error && (
                <IconButton edge="end" onClick={handleClick}>
                  <ArrowDropDownIcon />
                </IconButton>
              )}
            </>
          ),
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {gradeLevels?.map((grade) => (
          <MenuItem
            sx={{ width: "100%" }}
            key={grade}
            onClick={() => handleClose(grade)}
          >
            {grade}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
